import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    description:
      'Is your company or a person in your company (manager, beneficial owners, employees) targeted by economic or financial sanctions?',
    descriptionMandatee:
      'Is your client’s company or a person in your client’s company (manager, beneficial owners, employees) targeted by economic or financial sanctions?',
    nextButtonLabel: 'Confirm',
    title: 'About {legalName}:',
    titleNoLegalName: 'About your company:',
  },
  fr: {
    description:
      'Votre entreprise ou une personne de votre entreprise (dirigeant, bénéficiaires effectifs, salariés) est-elle visée par des sanctions économiques ou financière ?',
    descriptionMandatee:
      'L’entreprise de votre client•e ou une personne de l’entreprise de votre client•e (dirigeant, bénéficiaires effectifs, salariés) est-elle visée par des sanctions économiques ou financière ?',
    nextButtonLabel: 'Confirmer',
    title: 'À propos de {legalName} :',
    titleNoLegalName: 'À propos de votre entreprise :',
  },
} as const);
